var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSelfIconBlue(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 20,
    viewBox: "0 0 22 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.1666 7.08108C17.1666 8.78271 15.7489 10.1622 14 10.1622C12.2511 10.1622 10.8333 8.78271 10.8333 7.08108C10.8333 5.37945 12.2511 4 14 4C15.7489 4 17.1666 5.37945 17.1666 7.08108Z",
    fill: "#5555FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.466 12.2372C11.4034 11.3252 12.6744 10.8122 14 10.8108C15.3256 10.8122 16.5966 11.3252 17.534 12.2372C18.4714 13.1493 18.9986 14.3859 19 15.6757C19 15.7617 18.9649 15.8442 18.9024 15.905C18.8399 15.9658 18.7551 16 18.6667 16H9.33333C9.24493 16 9.16014 15.9658 9.09763 15.905C9.03512 15.8442 9 15.7617 9 15.6757C9.00141 14.3859 9.52865 13.1493 10.466 12.2372Z",
    fill: "#5555FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.98146 8.85135C9.98146 10.9784 8.24863 12.7027 6.11109 12.7027C3.97354 12.7027 2.24072 10.9784 2.24072 8.85135C2.24072 6.72431 3.97354 5 6.11109 5C8.24863 5 9.98146 6.72431 9.98146 8.85135Z",
    fill: "#5555FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.79181 15.2965C2.93749 14.1565 4.49087 13.5152 6.11111 13.5135C7.73135 13.5152 9.28473 14.1565 10.4304 15.2965C11.5761 16.4366 12.2205 17.9823 12.2222 19.5946C12.2222 19.7021 12.1793 19.8052 12.1029 19.8813C12.0265 19.9573 11.9229 20 11.8148 20H0.407407C0.299356 20 0.195731 19.9573 0.119327 19.8813C0.0429233 19.8052 0 19.7021 0 19.5946C0.00172538 17.9823 0.646127 16.4366 1.79181 15.2965Z",
    fill: "#5555FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.61133,
    y: 0.5,
    width: 14.8889,
    height: 15.25,
    rx: 0.5,
    stroke: "#5555FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelfIconBlue);
export default __webpack_public_path__ + "static/media/SelfIconBlue.5474e6827c9b47970241053821e2660c.svg";
export { ForwardRef as ReactComponent };